import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import classnames from '../../node_modules/classnames/index.js';
import { forwardRef } from 'react';
import { Spinner } from '../Spinner/Spinner.js';
import { spinnerSizeMap, textSizeMap } from './Button.consts.js';
import { getIconElement } from './Button.utils.js';
import modules_79b43374 from './Button.module.scss.js';
import { Typography } from '../Typography/Typography.js';

const Button = forwardRef(({ as, name, children, onClick, value, ariaLabel, "data-testid": testId, title, disabled = false, type, busy = false, className = "", size = "l", wide = false, squared = false, appearance = "secondary", emphasis = "medium", icon, iconPosition = "left", ...rest }, ref) => {
    const Component = as || "button";
    const iconElement = (jsx("span", { className: modules_79b43374.iconSpan, children: getIconElement({ icon }) }));
    // Button type is only applied if no 'as' prop is set. It defaults to 'button'.
    const buttonType = as ? null : type ? type : "button";
    if (!children && !ariaLabel) {
        console.error("@trustpilot/constellation-components - Button - Button must have text content or an aria label to be accessible.");
    }
    return (jsxs(Component, { name: name, className: classnames(modules_79b43374.button, modules_79b43374[size], modules_79b43374[`appearance-${appearance}`], {
            // Only apply emphasis styles for neutral appearances for phase 1 -
            [modules_79b43374[`emphasis-${emphasis}`]]: appearance === "neutral",
            [modules_79b43374.busy]: busy,
            [modules_79b43374.wide]: wide,
            [modules_79b43374.squared]: squared,
            [modules_79b43374.circle]: icon && !children,
            [modules_79b43374.disabled]: disabled,
            [modules_79b43374.iconLeft]: icon && children && iconPosition === "left",
            [modules_79b43374.iconRight]: icon && children && iconPosition === "right",
        }, className), disabled: disabled || busy, onClick: onClick, value: value, "aria-label": ariaLabel, title: title, ...(buttonType && { type: buttonType }), ...(testId && { "data-testid": testId }), ...rest, ref: ref, children: [busy && (jsx(Spinner, { appearance: "inherit", className: modules_79b43374.busySpinner, size: spinnerSizeMap[size] })), jsx(Typography, { variant: textSizeMap[size], as: "span", disableResponsiveSizing: true, appearance: "inherit", className: modules_79b43374.buttonText, children: icon ? (jsxs(Fragment, { children: [iconPosition === "left" && iconElement, children, iconPosition === "right" && iconElement] })) : (children) })] }));
});

export { Button };
//# sourceMappingURL=Button.js.map
